import { createBrowserHistory } from '@tanstack/react-location';

export const browserHistory = createBrowserHistory();

export default browserHistory;
